import { useInboxEntriesStore } from '../../store';

export const useActiveInboxEntryById = (id: string) =>
  useInboxEntriesStore((s) =>
    s.taskManager.activeTaskGroup.inboxEntries.find((e) => e?.id === id),
  );
